export default function searchUsersMutator( type, plugin, molten ) {

  if ( type !== 'Action' ) {
    return plugin
  }
  const { id } = plugin

  if ( id === 'link.SystemUsers' ) {
    return {
      ...plugin,
      layout : {
        sort : 'z.userManagement.1',
        group : [ 'userManagement' ],
        groupNames : [ 'User Management' ],
        groupIcons : [ 'fa-solid fa-users' ]
      }
    }
  }
  
  return plugin
}
